const language = {
    'pt': {
        photo: 'Carregar Foto de Perfil',
        noPhoto: 'Sem foto',
        overview: 'Visão Geral',
        naturalidade: 'Naturalidade',
        settings: 'Configurações',
        dados_fiscais: 'Dados Fiscais',
        contrato: 'Dados Contratuais',
        functions: 'Caracterização',
        departamentosEntidade: 'Elemento no(s) Departamento(s)',
        meus_dados: 'Meus dados',
        ações: 'Ações',
        add: 'Adicionar',
        add_new: 'Adicionar Nova Entidade',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        birthday: 'Data de nascimento',
        data_admissao: 'Data de Admissão',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Carregando Informações...',
        carregar_cv: 'Carregar CV',
        certificacao: 'Certificação em',
        city: 'Concelho',
        city_placeholder: 'Introduza a cidade',
        choose_profile: 'Escolha uma opção',
        close: 'Fechar',
        config: 'Configuração',
        contacto: 'Contacto',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        country: 'País',
        country_placeholder: 'Introduza o país',
        dark_mode: 'Dark mode',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        dates: 'Datas',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departament: 'Dados Departamentais',
        departamento: 'Departamento',
        funcoes: 'Funções / Responsabilidades',
        identification: 'Identificação',
        dep_emp: 'Departamentos Empresariais e Certificações',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        detalhes_departamento: 'Detalhes do Departamento',
        detalhes_utilizador: 'Detalhes do Utilizador',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        entity: 'Entidade',
        entity_edit: 'Editar entidade',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Username',
        entity_new: 'Novo entidade',
        entity_type: 'Tipo de Entidade',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Função / Responsabilidade',
        filter_placeholder: 'Procurar',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        photo: 'Carregar Foto',
        noPhoto: 'Sem foto',
        image_choose: 'Escolher imagem',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        language: 'Lingua',
        local: 'Localidade',
        local_placeholder: 'Introduza a localidade',
        arquivo: 'Arquivo',
        arquivo_placeholder: 'Introduza local de arquivo',
        login_data: 'Dados de Login',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        name: 'Nome',
        name_departamento: 'Nome do departamento',
        name_placeholder: 'Introduza o nome',
        no_departamento: 'Não há departamentos disponíveis',
        nome_responsavel: 'Nome do Responsável',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Confirmação da Password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        pdf_documents: 'Documentos PDF',
        pdf_documents_placeholder: 'Introduza o local do documento PDF',
        doc_choose: 'Escolher documento',
        personal_data: 'Dados Pessoais',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razão Social',
        relacao: 'Tipo de Relação',
        remove: 'Remover',
        remove_cancel: 'Não',
        remove_confirm: 'Sim',
        remove_error: 'Problema ao remover o atributo!',
        remove_success: 'Registo removido com sucesso!',
        remove_text: 'Tem a certeza que pretende continuar?',
        remove_title: 'Remover atributo',
        responsaveis: 'Responsáveis',
        save: 'Salvar',
        save_entidade: 'Salvar Alterações',
        select: 'Selecione uma opção',
        selec_departamento: 'Selecione um departamento',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        username: 'Username',
        username_placeholder: 'Introduza o username',

        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        cae: 'CAE',
        cae_placeholder: 'Introduza o CAE',
        iban: 'IBAN',
        iban_placeholder: 'Introduza o IBAN',
        nbss: 'Nº Beneficiário da Segurança Social',
        nbss_placeholder: 'Introduza o Número de Beneficiário da Segurança Social',
        ass: 'Admissão da Segurança Social',
        ass_placeholder: 'Admissão da Segurança Social',

        contribuinte: 'BI / CC',
        contribuinte_placeholder: 'Introduza o BI / CC',
        validade_contribuinte: 'Validade do BI / CC',
        validade_contribuinte_placeholder: 'Introduza a validade do BI / CC',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!',
        tag: 'Alcunha',
        tag_placeholder: 'Introduza a alcunha',
        observacoes: 'Observações',

        horas_semanais: 'Horas Semanais',
        horas_semanais_placeholder: 'Introduza as Horas Semanais',
        seguro_acidente_trabalho: 'Seguro Acidente de Trabalho',
        seguro_acidente_trabalho_placeholder: 'Introduza o Seguro Acidente de Trabalho',

        sexo: 'Sexo',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outro: 'Outro',

        estado_civil: 'Estado Civil',
        solteiro: 'Solteiro(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viúvo(a)',

        habilitacao_literaria: 'Habilitação Literária',
        ensino_basico: 'Ensino Básico',
        ensino_secundario: 'Ensino Secundário',
        licenciatura: 'Licenciatura',
        mestrado: 'Mestrado',
        doutoramento: 'Doutoramento',
        pos_doutoramento: 'Pós-Doutoramento',

        tipo_contrato: 'Tipo de Contrato',
        tipo_contrato_placeholder: 'Introduza o tipo de contrato',

        // Tipos de contrato:
        contrato_sem_termo: 'Contrato de trabalho sem termo (permanente ou efetivo)',
        contrato_termo_certo: 'Contrato de trabalho a termo certo (com duração definida)',
        contrato_termo_incerto: 'Contrato de trabalho a termo incerto (sem prazo final definido, mas com termo previsto por motivo justificado)',
        contrato_part_time: 'Contrato de trabalho a tempo parcial (part-time)',
        contrato_estagio: 'Contrato de estágio profissional',
        contrato_prestacao_servicos: 'Contrato de prestação de serviços (para trabalhadores independentes, com recibos verdes)',
        contrato_intermitente: 'Contrato de trabalho intermitente (trabalho por períodos intercalados)',
    },

    'en': {
        photo: 'Load Profile Photo',
        noPhoto: 'No photo',
        overview: 'Overview',
        naturalidade: 'Naturalness',
        settings: 'Settings',
        dados_fiscais: 'Fiscal Data',
        contrato: 'Contract Data',
        functions: 'Caraterization',
        departamentosEntidade: 'Element in Department(s)',
        tag: 'Tag',
        tag_placeholder: 'Insert tag',
        pdf_documents: 'PDF Documents',
        pdf_documents_placeholder: 'Enter the PDF document location',
        doc_choose: 'Choose document',     
        meus_dados: 'Personal data',
        ações: 'Actions',
        add: 'Add',
        add_new: 'Add New Entity',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsible Parties',
        birthday: 'Date of birth',
        data_admissao: 'Admission Date',
        cancel: 'Cancel',
        carregar: 'Loading Information...',
        carregar_cv: 'Load CV',
        certificacao: 'Certificate on',
        city: 'Municipality',
        city_placeholder: 'Enter the municipality',
        choose_profile: 'Choose an option',
        close: 'Close',
        config: 'Configuration',
        contacto: 'Contact',
        content: 'Content',
        content_edit: 'Edit content',
        content_list: 'Content list',
        content_new: 'New content',
        country: 'Country',
        country_placeholder: 'Enter the country',
        dark_mode: 'Dark mode',
        date_creation: 'Creation',
        date_last_update: 'Last update',
        date_publication: 'Publication',
        dates: 'Dates',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Error deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to proceed?',
        delete_title: 'Delete Record',
        departament: 'Departmental Data',
        departamento: 'Department',
        funcoes: 'Functions / Responsibilities',
        identification: 'Identification',
        dep_emp: 'Business Departments and Certifications',
        description: 'Description',
        description_placeholder: 'Enter a description',
        detalhes_departamento: 'Department Details',
        detalhes_utilizador: 'User Details',
        district: 'District',
        district_placeholder: 'Enter the district',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Error updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to proceed?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        entity: 'Entity',
        entity_edit: 'Edit entity',
        entity_externa: 'External Entities',
        entity_interna: 'Internal Entities',
        entity_list: 'Entity list',
        entity_name: 'Username',
        entity_new: 'New entity',
        entity_type: 'Entity Type',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Function / Responsability',
        filter_placeholder: 'Search',
        id: 'ID',
        identification_number: 'Identification number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validation',
        photo: 'Load Profile Photo',
        noPhoto: 'No photo',
        image: 'Image',
        image_choose: 'Choose image',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Error inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to proceed?',
        insert_title: 'New Record',
        language: 'Language',
        local: 'Locality',
        local_placeholder: 'Enter the locality',
        login_data: 'Login Data',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        name: 'Name',
        name_departamento: 'Department name',
        name_placeholder: 'Enter the name',
        no_departamento: 'No departments available',
        nome_responsavel: 'Responsible Party Name',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Password Confirmation',
        password_confirm: 'Continue',
        password_error: 'Error inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Element inserted successfully!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        personal_data: 'Personal Data',
        postal_code: 'Postal code',
        postal_code_placeholder: 'Enter the postal code',
        principal: 'Principal',
        profile: 'Profile',
        razao_social: 'Corporate Name',
        relacao: 'Relationship Type',
        remove: 'Remove',
        responsaveis: 'Responsible Parties',
        save: 'Save',
        save_entidade: 'Save Changes',
        select: 'Select an option',
        selec_departamento: 'Select a department',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        tipo: 'Type',
        type: 'Client type',
        type_identification: 'Identification type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the client type',
        username: 'Username',
        username_placeholder: 'Enter the username',

        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        cae: 'CAE',
        cae_placeholder: 'Enter the CAE',
        ibr: 'IBAN',
        ibr_placeholder: 'Enter the IBAN',
        nbss: 'Social Security Beneficiary Number',
        nbss_placeholder: 'Enter the Social Security Beneficiary Number',
        ass: 'Social Security Admission',
        ass_placeholder: 'Enter the Social Security Admission',

        contribuinte: 'BI / CC',
        contribuinte_placeholder: 'Enter the BI / CC',
        validade_contribuinte: 'BI / CC Validity',
        validade_contribuinte_placeholder: 'Enter the BI / CC validity',
        village: 'Parish',
        village_placeholder: 'Enter the parish',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Error inserting record!',
        warning_success: 'Record inserted successfully!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!',
        observacoes: 'Observations',

        sexo: 'sex',
        masculino: 'male',
        feminino: 'female',
        outro: 'other',

        estado_civil: 'Marital Status',
        solteiro: 'single',
        casado: 'married',
        divorciado: 'divorced',
        viuvo: 'widowed',

        habilitacao_literaria: 'Literary Qualification',
        ensino_basico: 'Basic Education',
        ensino_secundario: 'Secondary Education',
        licenciatura: 'Bachelor\'s Degree',
        mestrado: 'Master\'s Degree',
        doutoramento: 'PhD',
        pos_doutoramento: 'Postdoctoral',


        horas_semanais: 'Weekly Hours',
        horas_semanais_placeholder: 'Enter Weekly Hours',
        seguro_acidente_trabalho: 'Work Accident Insurance',
        seguro_acidente_trabalho_placeholder: 'Enter Work Accident Insurance',

        tipo_contrato: 'Contract Type',
        tipo_contrato_placeholder: 'Enter the contract type',

        // Contract types:
        contrato_sem_termo: 'Permanent employment contract (indefinite or effective)',
        contrato_termo_certo: 'Fixed-term employment contract (with defined duration)',
        contrato_termo_incerto: 'Indefinite-term employment contract (without final deadline but with expected term for justified reason)',
        contrato_part_time: 'Part-time employment contract',
        contrato_estagio: 'Professional internship contract',
        contrato_prestacao_servicos: 'Service provision contract (for self-employed workers, with green receipts)',
        contrato_intermitente: 'Intermittent employment contract (work in alternating periods)',
    },
    'es': {
        ações: 'Acciones',
        add: 'Añadir',
        add_new: 'Añadir nuevo',
        adicionar_departamento: 'Añadir Departamento',
        adicionar_entidade: 'Añadir Responsables',
        birthday: 'Fecha de nacimiento',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Cargando Información...',
        city: 'Municipio',
        city_placeholder: 'Introduce el municipio',
        choose_profile: 'Elige una opción',
        close: 'Cerrar',
        config: 'Configuración',
        contacto: 'Contacto',
        content: 'Contenido',
        content_edit: 'Editar contenido',
        content_list: 'Lista de contenidos',
        content_new: 'Nuevo contenido',
        country: 'País',
        country_placeholder: 'Introduce el país',
        dark_mode: 'Modo oscuro',
        date_creation: 'Creación',
        date_last_update: 'Última actualización',
        date_publication: 'Publicación',
        dates: 'Fechas',
        delete: 'Eliminar',
        delete_cancel: 'No',
        delete_confirm: 'Sí',
        delete_error: '¡Error al eliminar el registro!',
        delete_success: '¡Registro eliminado con éxito!',
        delete_text: '¿Está seguro de que desea continuar?',
        delete_title: 'Eliminar Registro',
        departament: 'Datos Departamentales',
        departamento: 'Departamento',
        dep_emp: 'Departamentos Empresariales y Certificaciones',
        description: 'Descripción',
        description_placeholder: 'Introduce una descripción',
        detalhes_departamento: 'Detalles del Departamento',
        detalhes_utilizador: 'Detalles del Usuario',
        district: 'Distrito',
        district_placeholder: 'Introduce el distrito',
        edit: 'Editar',
        edit_cancel: 'No',
        edit_confirm: 'Sí',
        edit_error: '¡Error al actualizar el registro!',
        edit_success: '¡Registro actualizado con éxito!',
        edit_text: '¿Está seguro de que desea continuar?',
        edit_title: 'Editar Registro',
        email: 'Correo electrónico',
        email_placeholder: 'Introduce el correo electrónico',
        entity: 'Entidad',
        entity_edit: 'Editar entidad',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Username',
        entity_new: 'Nueva entidad',
        entity_type: 'Tipo de Entidad',
        entity_nature: 'Natureza jurídica',
        entity_function: 'Função / Responsabilidade',
        filter_placeholder: 'Buscar',
        id: 'ID',
        identification_number: 'Número de identificación',
        identification_number_placeholder: 'Introduce el número de identificación',
        identification_validation: 'Validación',
        image: 'Imagen',
        image_choose: 'Elegir imagen',
        insert_cancel: 'No',
        insert_confirm: 'Sí',
        insert_error: '¡Error al insertar el registro!',
        insert_success: '¡Registro insertado con éxito!',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_title: 'Nuevo Registro',
        language: 'Idioma',
        local: 'Localidad',
        local_placeholder: 'Introduce la localidad',
        login_data: 'Datos de Inicio de Sesión',
        morada: 'Dirección',
        morada_placeholder: 'Introduce la dirección',
        name: 'Nombre',
        name_departamento: 'Nombre del departamento',
        name_placeholder: 'Introduce el nombre',
        no_departamento: 'No hay departamentos disponibles',
        nome_responsavel: 'Nombre del Responsable',
        password: 'Contraseña',
        password_cancel: 'No',
        password_confirmation: 'Confirmación de la Contraseña',
        password_confirm: 'Continuar',
        password_error: '¡Error al insertar el elemento!',
        password_placeholder: 'Introduce la contraseña',
        password_success: '¡Elemento insertado con éxito!',
        password_text: 'Las contraseñas no coinciden.',
        password_title: '¡Contraseña!',
        personal_data: 'Datos Personales',
        postal_code: 'Código postal',
        postal_code_placeholder: 'Introduce el código postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razón Social',
        relacao: 'Tipo de Relación',
        remove: 'Eliminar',
        responsaveis: 'Responsables',
        save: 'Guardar',
        save_entidade: 'Guardar Cambios',
        select: 'Seleccione una opción',
        selec_departamento: 'Seleccione un departamento',
        table_actions: 'Acciones',
        table_all: 'Todos',
        table_count: 'Cantidad',
        table_date: 'Fecha',
        table_empty: 'Sin Resultados',
        table_parent: 'Padre',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Miniatura',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduce el título',
        tlf: 'Teléfono',
        tlf_placeholder: 'Introduce el número de teléfono',
        tlm: 'Móvil',
        tlm_placeholder: 'Introduce el número de móvil',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificación',
        type_identification_placeholder: 'Introduce el tipo de identificación',
        type_placeholder: 'Introduce el tipo de cliente',
        username: 'Nombre de usuario',
        username_placeholder: 'Introduce el nombre de usuario',
        vat: 'NIF',
        vat_placeholder: 'Introduce el NIF',
        cae: 'CAE',
        cae_placeholder: 'Introduce el CAE',
        village: 'Parroquia',
        village_placeholder: 'Introduce la parroquia',
        warning_cancel: 'No',
        warning_confirm: 'Continuar',
        warning_error: '¡Error al insertar el registro!',
        warning_success: '¡Registro insertado con éxito!',
        warning_text: 'El nombre de usuario ya existe en el sistema.',
        warning_title: '¡Advertencia!'
    },
}

module.exports = {
    language
};